module.exports = __webpack_public_path__ + "img/電気回路_4_3_5.a91738ac.png";